import { render, staticRenderFns } from "./index.vue?vue&type=template&id=688dcc12&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=688dcc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../Users/zhc/Documents/CF40/CF40-Java/cf40_pc_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688dcc12",
  null
  
)

export default component.exports